import http from '@/biz/http.mjs'
import {writeFileToDisk} from '@/script/file.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, prjId, sVer} = map.data

    if ('SA_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = async () => {
        const {blob, fileName} = await runAsync(
            () => http.post('/bizData/export', {prjId, sVer}),
            {action: '导出业务数据'}
        )

        writeFileToDisk(blob, {suggestedName: fileName})
    }

    return {
        label: '导出业务数据',
        onClick,
    }
}
